import { ethers } from 'ethers';

import useWrappedRPC from './useWrappedRPC';
import useEmbeddedWallet from './useEmbeddedWallet';

function useWithdraw() {
  const { sendTransactionWithGas } = useWrappedRPC();
  const { getEmbeddedWallet } = useEmbeddedWallet();

  const handleWithdraw = async (receivedWalletAddress, ethAmount) => {
    try {
      await getEmbeddedWallet();

      const weiValue = ethers.utils.parseEther(ethAmount);
      const hexWeiValue = ethers.utils.hexlify(weiValue);
      const transactionRequest = {
        to: receivedWalletAddress,
        value: hexWeiValue,
      };

      const txReceipt = await sendTransactionWithGas(transactionRequest);
      if (!txReceipt) throw new Error('Transaction failed on blockchain');

      return {
        success: true,
        message: 'Send transaction successful',
        data: txReceipt.hash,
      };
    } catch (error) {
      console.error('Withdraw transaction failed:', error);
      return { success: false, message: error.message };
    }
  };

  return { handleWithdraw };
}

export default useWithdraw;
